import { useState } from "react";

export const useColumnMapping = (initialMappings) => {
  const [mappings, setMappings] = useState(initialMappings);

  const calculateSimilarity = (str1, str2) => {
    const s1 = str1.toLowerCase().replace(/[^a-z]/g, "");
    const s2 = str2.toLowerCase().replace(/[^a-z]/g, "");

    if (s1 === s2) return 1;
    if (s1.includes(s2) || s2.includes(s1)) return 0.8;

    const overlap = [...s1].filter((char) => s2.includes(char)).length;
    return overlap / Math.max(s1.length, s2.length);
  };

  const calculateConfidence = (sourceColumn, targetMapping) => {
    if (!targetMapping) return "low";
    const similarity = calculateSimilarity(sourceColumn, targetMapping);
    if (similarity >= 0.7) return "high";
    if (similarity >= 0.4) return "medium";
    return "low";
  };


  const updateMapping = (sourceColumn, newTargetMapping, newConfidence) => {
  setMappings((prevMappings) =>
    prevMappings.map((mapping) =>
      mapping.sourceColumn === sourceColumn
        ? {
            ...mapping,
            targetMapping: newTargetMapping,
            confidence: newConfidence || mapping.confidence, // fallback to existing if not sent
          }
        : mapping
    )
  );
};

  const getConfidenceCounts = () => {
    return mappings.reduce(
      (acc, mapping) => {
        acc[mapping.confidence] = (acc[mapping.confidence] || 0) + 1;
        return acc;
      },
      { high: 0, medium: 0, low: 0 }
    );
  };

  return { mappings, updateMapping, getConfidenceCounts, setMappings };
};